import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import useLangTranslation from "../../../customHooks/languageProvider";
import { getSocialApps } from "../../AxiosRtk/SocialApps/SOCIALAPPCURD";
import { useSelector, useDispatch } from "react-redux";
import CommonStatus from "../Common/CommonStatus";
import useDeviceStatus from "../../../customHooks/deviceStatusProvider";
import moment from "moment";
import { deleteActivityService } from "../../AxiosRtk/Miscellaneous/MISCURD";
import { setShowMessage, setErrorInfo } from "../../AxiosRtk/successMessage";
import { handleStartDateCommon } from "../../../../utils/helper";
import SocialMediaTableRow from "./SocialMediaTableRow";
import { constant } from "../../../../utils/constant";
import LoadingIndicator from "../../../../setup/Loader/LoaderIndicator";
import AddNewApp from "../modals/AddNewApp";
import Select from "react-select";
import useDurationOption from "../../../customHooks/durationOption";
import KidImage from "../../../shared/KidImage/KidImage";
import DateFilter from "../../../shared/DateFilter/DateFilter";
import { useDashboardDataProvider } from "../../../customHooks/dashboardDataProvider";

const SocialMediaCommunication = () => {
  const {
    selectedKidId,
    kidList,
    kidDevicesList,
    selectedDeviceData,
    allAppData,
  } = useSelector(({ dashboard }) => dashboard);

  const { socialMediaSelectedAppId } = useSelector(
    ({ socialApp }) => socialApp
  );
  const { handleDeviceSelection } = useDashboardDataProvider();
  const [deviceOptions, setDeviceOptions] = useState([]);
  const [filterModal, setFilterModal] = useState(false);
  const [socialApps, setSocialApps] = useState([]);
  // const [showModal, setShowModal] = useState(false);
  const [appId, setAppId] = useState("");
  const [appData, setApppData] = useState(null);
  const [deviceId, setDeviceId] = useState("");
  // const [type, setType] = useState(1);
  const [loader, setLoader] = useState(false);
  const [deleteItems, setDeleteItems] = useState({ selectAll: false });
  const [kidData, setKidData] = useState(null);
  const [localListData, setLocalListData] = useState([]);
  const [socialMediaData, setSocialMediaData] = useState([]);
  const [startDate, setStartDate] = useState(
    moment().startOf("day").format("YYYY-MM-DD HH:mm:ss")
  );
  const itemsPerPage = 1000000;
  const [pageNumber, setPageNumber] = useState(1);
  const history = useHistory();
  const dispatch = useDispatch();
  // const { getImage } = useKidListFunctionality();
  const { getLangTranslation } = useLangTranslation();
  const { durationOptionsFunction } = useDurationOption();
  const [selectedDuration, setSelectedDuration] = useState(1);
  const durationOptions = durationOptionsFunction();
  const [deviceStatus, setDeviceStatus] = useState("");
  const initialEndDate = moment().locale("en").format("YYYY-MM-DD HH:mm:ss");
  const [endDate, setEndDate] = useState(initialEndDate);
  const { getDeviceStatusData } = useDeviceStatus(
    deviceStatus,
    setDeviceStatus
  );
  function getSocialMediaCommunicationData() {
    if (selectedDeviceData && startDate) {
      const filterDate = moment(startDate)
        .locale("en")
        .format("YYYY-MM-DD HH:mm:ss");
      const obj = {
        deviceId: selectedDeviceData?.ID,
        startDate: startDate,
        endDate: endDate,
        pageNo: pageNumber,
        itemsPerPage: itemsPerPage,
      };

      if (appData) {
        obj.appPackageName = appData?.AppPackageName;
      }

      setLoader(true);
      getSocialApps(obj)
        .then((res) => {
          if (pageNumber == 1) setSocialMediaData(res?.data?.result);
          else setSocialMediaData([...socialMediaData, ...res?.data?.result]);
          setLocalListData(res?.data?.result);
        })
        .catch((err) => {
          console.log("rating catch error ==>>", err?.response?.data?.message);
        })
        .finally(() => {
          setLoader(false);
          setFilterModal(false);
        });
    }
  }

  useEffect(() => {
    if (pageNumber == 1) getSocialMediaCommunicationData();
    else setPageNumber(1);
  }, [selectedDeviceData, startDate, endDate]);

  useEffect(() => {
    if (allAppData?.length > 0 && socialMediaData?.length > 0) {
      const socialAppsTemp = allAppData?.filter((allAppItem) => {
        const socialMediaDataIndex = socialMediaData?.findIndex(
          (socialMediaIndex) =>
            allAppItem?.AppPackageName === socialMediaIndex?.packageName
        );
        return socialMediaDataIndex > -1;
      });
      setSocialApps(
        socialAppsTemp?.length > socialApps?.length
          ? socialAppsTemp
          : socialApps
      );
    }
  }, [allAppData, socialMediaData]);

  useEffect(() => {
    if (kidList.length > 0 && selectedKidId) {
      const kid = kidList?.find((item) => item?.ID === selectedKidId);
      setKidData(kid);
    }
  }, [kidList, selectedKidId]);

  useEffect(() => {
    if (selectedDeviceData) {
      getDeviceStatusData(selectedDeviceData?.ID);
    } else {
      setDeviceStatus("");
    }
  }, [selectedDeviceData]);

  useEffect(() => {
    if (socialApps?.length > 0 && appId) {
      const app = socialApps?.find(
        (item) => parseInt(item?.ID) === parseInt(appId)
      );
      setApppData(app);
    } else {
      setApppData(null);
    }
  }, [appId]);

  function handleInputCheck(e) {
    const { id, checked } = e.target;
    let tempSocialMediaData = [...socialMediaData];
    tempSocialMediaData = tempSocialMediaData?.map((item) => {
      if (parseInt(item?.socialHistorId) === parseInt(id)) {
        if (!checked) {
          delete item.isChecked;
        } else {
          item.isChecked = checked;
        }
      }
      return item;
    });
    setSocialMediaData(tempSocialMediaData);
  }

  function getSocialMediaHistoryIds(itemsNos = "") {
    let idStr = "";
    if (itemsNos === "ALL") {
      socialMediaData.forEach((item) => {
        idStr = idStr + item?.socialHistorId.toString() + ",";
      });
    } else {
      const tempArr = socialMediaData?.filter((item) => item?.isChecked);
      tempArr.forEach((item) => {
        idStr = idStr + item?.socialHistorId.toString() + ",";
      });
    }
    return idStr?.slice(0, idStr?.length - 1);
  }

  async function handleDeleteClick() {
    if (socialMediaData?.length === 0) {
      dispatch(
        setErrorInfo({
          errorInfo: true,
          defaultTitle: "Data not available",
          title: "DATA_NOT_AVAILABLE",
        })
      );
      return;
    }

    const payload = {
      deviceId: selectedDeviceData?.ID,
      activityType: "SOCIAL",
    };

    if (deleteItems?.selectAll) {
      payload.isDeleteAll = 1;
      payload.socialActivityId = getSocialMediaHistoryIds("ALL");
    } else {
      payload.socialActivityId = getSocialMediaHistoryIds();
    }

    setLoader(true);
    try {
      const { data } = await deleteActivityService(payload);
      if (data) {
        dispatch(
          setShowMessage({
            showMessage: true,
            defaultMessage: data?.message,
            message: data?.message,
          })
        );
        setSocialMediaData([]);
        getSocialMediaCommunicationData();
      }
    } catch (error) {
      console.log(
        "social media delete data catch error ==>>",
        error?.response?.data?.message
      );
    } finally {
      setLoader(false);
    }
  }

  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap separator space-24">
            <div
              className="list-item c-pointer"
              onClick={() => history.goBack()}
            >
              <div className="list-content">
                <div className="d-inline-flex align-items-center lh-1">
                  <span className="text-blue-900 fs-5">
                    <i className="icon-arrow-left" />
                  </span>
                  <h3 className="text-blue-900 mb-0">
                    {" "}
                    {getLangTranslation(
                      "SOCIAL_MEDIA_COMMUNICATION_TITLE",
                      "Social media communications"
                    )}
                  </h3>
                </div>
              </div>
            </div>
            <div className="list-item">
              <KidImage imageUrl={kidData?.image} gender={kidData?.gender} />
              <div>
                <h5 className="text-blue-900 mb-0">{kidData?.childName}</h5>
                <CommonStatus status={deviceStatus} />
              </div>
            </div>
            <div className="list-item content-300 w-100">
              <Select
                className="custom-select col-lg-8"
                classNamePrefix="custom-select"
                placeholder={getLangTranslation(
                  "SOCIAL_MEDIA_COMMUNICATION_HISTORY_SELECT_DEVICE_TITLE",
                  "Active device"
                )}
                options={deviceOptions}
                value={
                  deviceOptions?.find(
                    (item) => item?.value == selectedDeviceData?.ID
                  ) || ""
                }
                onChange={handleDeviceSelection}
                isSearchable={false}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-6 mb-6">
            {appData && (
              <h5 className="text-blue-900 mb-0">
                {getLangTranslation(
                  "SOCIAL_MEDIA_COMMUNICATION_HISTORY_MESSAGES_FROM",
                  "Messages from $app_name$"
                )?.replace("$app_name$", appData?.app_name)}
              </h5>
            )}

            <div className="d-flex align-items-center flex-wrap gap-6">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  name="ALL_SELECT"
                  id="selectAll"
                  checked={deleteItems?.selectAll}
                  onChange={(e) => {
                    setDeleteItems({
                      ...deleteItems,
                      selectAll: e.target.checked,
                    });
                  }}
                />
                <label className="form-check-label" htmlFor="selectAll">
                  {getLangTranslation(
                    "SOCIAL_MEDIA_COMMUNICATION_HISTORY_SELECT_ALL",
                    "Select all"
                  )}
                </label>
              </div>
              <button
                className="btn btn-outline-primary"
                type="button"
                disabled={loader}
                onClick={() => handleDeleteClick()}
              >
                {loader ? (
                  <LoadingIndicator
                    width={100}
                    height={20}
                    color={constant?.color?.DODGER_BLUE}
                  />
                ) : (
                  getLangTranslation(
                    "SOCIAL_MEDIA_COMMUNICATION_HISTORY_BUTTON_DELETE_SELECTED",
                    "Delete selected"
                  )
                )}
              </button>
            </div>
            <div className="d-flex align-items-center gap-3 justify-content-end flex-fill">
              <DateFilter
                startDate={startDate}
                endDate={endDate}
                setEndDate={setEndDate}
                setStartDate={setStartDate}
                selectedDuration={selectedDuration}
              />
              <Select
                className="custom-select col-lg-4"
                classNamePrefix="custom-select"
                placeholder="Select"
                onChange={(val) => {
                  handleStartDateCommon(
                    val,
                    setStartDate,
                    setSelectedDuration,
                    setEndDate
                  );
                }}
                options={durationOptions}
                value={
                  durationOptions?.find(
                    (item) => item?.value == selectedDuration
                  ) || ""
                }
              />
              <span
                className="icon-wrap pt-cursor"
                onClick={() => setFilterModal(true)}
              >
                <i className="icon-filter" />
              </span>
            </div>
          </div>

          <div className="table-responsive">
            {/* <InfiniteScroll
              dataLength={socialMediaData?.length}
              scrollThreshold={0.5}
              next={() => fetchData()}
              hasMore={localListData?.length > 0}
              scrollableTarget="scrollablescrll"
              className="w-100"
            > */}
            <table className="table table-striped">
              <thead>
                <tr>
                  <th className="v-middle">
                    <div className="form-check"></div>
                  </th>
                  <th className="v-middle">App</th>
                  <th className="v-middle">
                    {getLangTranslation("CHILD_MESSAGE_HINT", "Message")}
                  </th>
                  <th className="v-middle">
                    {getLangTranslation("DATE", "Date")}
                  </th>
                  <th className="v-middle">Text Type</th>
                  <th className="v-middle">
                    {getLangTranslation(
                      "DEVICE_DETAIL_FIND_DEVICE_STATUS",
                      "Status"
                    )}
                  </th>
                </tr>
              </thead>
              <tbody>
                {socialMediaData?.map((item, index) => {
                  return (
                    <SocialMediaTableRow
                      item={item}
                      key={index}
                      getLangTranslation={getLangTranslation}
                      handleInputCheck={handleInputCheck}
                    />
                  );
                })}
              </tbody>
            </table>
            {/* </InfiniteScroll> */}
            {socialMediaData?.length === 0 && !loader && (
              <div className="text-center my-1">
                --- {getLangTranslation("NO_DATA_LOG", "No Data Found")} ---
              </div>
            )}
          </div>
        </div>
      </div>

      <AddNewApp
        showModal={filterModal}
        closeModal={() => setFilterModal(false)}
        allAppData={socialApps}
        appId={appId}
        setAppId={setAppId}
        handleContinueBtn={getSocialMediaCommunicationData}
        loader={loader}
        heading="SOCIAL_MEDIA_SELECT_APPS"
        headingVal="Select apps"
        setSocialMediaData={setSocialMediaData}
        setPageNumber={setPageNumber}
      />
    </>
  );
};

export default SocialMediaCommunication;
